import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 20l2.463 -5.541m1.228 -2.764l.309 -.695l.8 1.8","key":"svg-0"}],["path",{"d":"M18 18h-5.1","key":"svg-1"}],["path",{"d":"M8.747 8.748c-.66 2.834 -2.536 4.252 -4.747 4.252","key":"svg-2"}],["path",{"d":"M4 6.371l2.371 0","key":"svg-3"}],["path",{"d":"M5 9c0 2.144 2.252 3.908 6 4","key":"svg-4"}],["path",{"d":"M3 3l18 18","key":"svg-5"}]]

const IconLanguageOff = createReactComponent('outline', 'language-off', 'LanguageOff', __iconNode);

export default IconLanguageOff;